import context from '../context'
import { allowErrorDialog } from '@/utils/fetch'
import getComponentKey from '@/utils/getComponentKey'

const initialState = {
  fetching: false,
  updating: false,
  deleting: false,
  reportTemplateCategory: null,
  gridKey: getComponentKey(),
  dialogKey: getComponentKey()
}

const actionTypes = {
  fetching: 'reportTemplateCategory/fetching',
  fetched: 'reportTemplateCategory/fetched',
  updating: 'reportTemplateCategory/updating',
  updated: 'reportTemplateCategory/updated',
  deleting: 'reportTemplateCategory/deleting',
  deleted: 'reportTemplateCategory/deleted',
  error: 'reportTemplateCategory/error'
}

const actionCreators = {
  get: (id) => (dispatch) => {
    dispatch({ type: actionTypes.fetching })
    if (id === 0) {
      dispatch({ type: actionTypes.fetched, payload: { id, name: '', latinName: '' } })
    } else {
      context.api.reportTemplateCategoryService.get(id, allowErrorDialog)
        .then(response => {
          dispatch({ type: actionTypes.fetched, payload: response })
        }).catch(() => dispatch({ type: actionTypes.error, update: { fetching: false } }))
    }
  },
  save: (dto, callback) => (dispatch) => {
    dispatch({ type: actionTypes.updating })
    context.api.reportTemplateCategoryService.save(dto, allowErrorDialog)
      .then(() => {
        dispatch({ type: actionTypes.updated })
        if (typeof callback === 'function') { callback() }
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { updating: false } }))
  },
  delete: (id) => (dispatch) => {
    dispatch({ type: actionTypes.deleting })
    context.api.reportTemplateCategoryService.delete(id, allowErrorDialog)
      .then(() => dispatch({ type: actionTypes.deleted }))
      .catch(() => dispatch({ type: actionTypes.error, update: { deleting: false } }))
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetching: return { ...state, fetching: true }
    case actionTypes.fetched: return { ...state, fetching: false, reportTemplateCategory: action.payload, dialogKey: getComponentKey() }
    case actionTypes.updating: return { ...state, updating: true }
    case actionTypes.updated: return { ...state, updating: false, gridKey: getComponentKey() }
    case actionTypes.deleting: return { ...state, deleting: true }
    case actionTypes.deleted: return { ...state, deleting: false, gridKey: getComponentKey() }
    case actionTypes.error: return { ...state, ...action.update }
    default:
    {}
  }
  return state
}

export { actionCreators, reducer }



// WEBPACK FOOTER //
// ./src/store/reportTemplateCategory.js